import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Group, GroupGutter } from '@as/cotopaxi';
import { ExpertReview } from './ExpertReview';
import { useSelector } from 'react-redux';
import { makeGetExpertReviews } from '../../redux/product/selectors/ProductSelector';
import { Divider } from '@yonderland/andes-react';
export const ExpertReviews = () => {
    const expertReviews = useSelector(makeGetExpertReviews());
    return (_jsx(Group, { column: true, gutter: GroupGutter.LARGE, children: expertReviews.map((review, index) => (_jsxs(Fragment, { children: [index > 0 && _jsx(Divider, {}), _jsx(ExpertReview, { expertReview: review }, review.id)] }, review.id))) }));
};
